import { CategoryEnum, Metadata, Price } from '@classifieds-sell/datalayer';
import { BASE_PACKAGE_CODE_KEY } from '../constants/property-promote.constants';

export const getListingPrice = (
    categoryId: CategoryEnum,
    draftData: any,
    metadata: Metadata
): number | null => {

    switch (categoryId) {
        case CategoryEnum.residentialForRent:
            return draftData.propertyInformation.pricePerWeek;
        case CategoryEnum.residentialForSale:
            return draftData.propertyInformation.rateableValue
                || getMinValueOfMaxBand(metadata);
        case CategoryEnum.newHomesHouseAndLand:
        case CategoryEnum.newHomesNewApartment:
        case CategoryEnum.newHomesNewHouse:
        case CategoryEnum.newHomesNewTownhouseAndTerraced:
        case CategoryEnum.rural:
            return draftData.propertyInformation.propertySalePrice;
        default:
            return 0;
    }
};
/**
 * @description try to get least price to charge for max band
 * @param metadata
 * @returns min value of max band
 */
const getMinValueOfMaxBand = (metadata: Metadata) => {
    // the method is only invoked for resi4Sale private
    // hence fee[0] should always has value
    const prices = metadata.fees[0].prices;
    const minnValueOfMaxBand = Math.max(...prices.map(x => x.minValue));
    return minnValueOfMaxBand;
};

export const getPackagePrice = (
    prices: Price[],
    listingPrice: number | null
): number => {
    if (!listingPrice) {
        return prices.find(
            (price: { minValue: number; maxValue: number; price: number }) =>
                price.maxValue === null
        ).price;
    }
    let priceBandCost = prices.find(
        (price: { minValue: number; maxValue: number; price: number }) =>
        (price.minValue <= listingPrice &&
            price.maxValue >= listingPrice)
    );
    // price didn't fit in a normal price band, give it the default no CV or high CV pricing
    if (!priceBandCost) {
        priceBandCost = prices.find((price: { minValue: number; maxValue: number; price: number }) =>
            price.minValue <= listingPrice && price.maxValue === null);
    }
    return priceBandCost.price;
};

export const isIncreasePricingTier = (
    prices: Price[],
    currentListingPrice: number | null,
    newListingPrice: number | null
): boolean => {
    if (!currentListingPrice || !newListingPrice) {
        return false;
    }

    const currentPrice = getPackagePrice(prices, currentListingPrice);
    const newPrice = getPackagePrice(prices, newListingPrice);
    return newPrice > currentPrice;
};

export const isBasePackageSelection = (packageCode: string): boolean => packageCode === BASE_PACKAGE_CODE_KEY;